import dayjs, { Dayjs } from "dayjs";

type GetToleranceTimeParams = {
  currentData?: string | Date | Dayjs;
  toleranceTime?: string;
  expiredText?: string;
  format?: string;
  onExpired?: () => void;
};
export function getToleranceTime({ currentData, toleranceTime = "00:00", expiredText = "Esgotado", format = "HH:mm:ss", onExpired }: GetToleranceTimeParams) {
  if (!currentData) {
    return {
      time: expiredText,
      isExhausted: true,
      isInTolerance: false
    };
  }

  const now = dayjs();
  const time = dayjs(currentData);

  if (!time.isValid()) {
    return {
      time: expiredText,
      isExhausted: true,
      isInTolerance: false
    };
  }

  const [hours, minutes] = toleranceTime.split(":").map(Number);

  const hasReachedBaseTime = now.isAfter(time, "second") || now.isSame(time, "second");
  const deadline = time.add(hours, "hour").add(minutes, "minute");
  const diffMs = deadline.diff(now);

  const isExhausted = now.isAfter(deadline, "second") || now.isSame(deadline, "second");
  const isInTolerance = hasReachedBaseTime && !isExhausted;

  if (isExhausted) {
    onExpired?.();
  }

  const timeLeft = dayjs.utc(Math.max(0, diffMs)).format(format);

  return {
    time: isExhausted ? expiredText : timeLeft,
    isExhausted,
    isInTolerance
  };
}
